export class LoginRequest
{
    Email?: string;
    Username?: string;
    Password?: string;
    CaptchaCode?: string;
    TwoFactorCode?: string;
    CustomerIdentity?: string;
    ClientType?: string;
}